var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H3C1.35 0 0 1.35 0 3v21c0 1.65 1.35 3 3 3h21c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3zm-8.955 6.09l1.59-1.59 2.115 2.115L20.865 4.5l1.59 1.59-2.115 2.115 2.115 2.115-1.59 1.59-2.115-2.1-2.115 2.115-1.59-1.59L17.16 8.22l-2.115-2.13zm-10.17.99h7.5v2.25h-7.5V7.08zM12.75 19.5h-3v3H7.5v-3h-3v-2.25h3v-3h2.25v3h3v2.25zm9.75 1.875H15v-2.25h7.5v2.25zm0-3.75H15v-2.25h7.5v2.25z",
    fill: "#FFA700"
  })));
}
export default SvgCalculatorInput;